import { useTranslations } from 'next-intl'

import { ContentText, fontWeights, spacing } from '@fortum/elemental-ui'

import { getPriceBaseOnCustomerType } from '@/open-web/utils/getPriceBaseOnCustomerType'
import { usePriceToString } from '@/shared/hooks/usePriceToStringFormatter'
import { useTheme } from '@/shared/hooks/useTheme'

import type { PriceElementProps } from './types'
import { defineTheme } from '../utils'

export type StartFeeProps = PriceElementProps

export const StartFee = ({
  tariffElement,
  contractTemplate,
  renderLabel = true,
  priceSize = 'xl',
  theme = 'light',
}: StartFeeProps) => {
  const tPurchaseFlow = useTranslations('purchaseFlow')
  const tAriaLabels = useTranslations('ariaLabels')
  const { colors } = useTheme()
  const colorConfiguration = defineTheme(colors, theme)
  const { formatPriceWithUnitNoAmount } = usePriceToString()

  const startupFeePrice = getPriceBaseOnCustomerType(
    tariffElement.prices?.[0],
    contractTemplate.customerType,
  )

  const startupFeeToDisplay = formatPriceWithUnitNoAmount(
    startupFeePrice,
    tariffElement.priceUnit,
    {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    },
  )

  return (
    <>
      {renderLabel && (
        <ContentText size="s" color={colorConfiguration.crossedPrice} mt={spacing.xxxs}>
          {tPurchaseFlow('startupFee')}
        </ContentText>
      )}
      <ContentText
        size={priceSize}
        fontWeight={fontWeights.medium}
        color={colorConfiguration.price}
        aria-label={tAriaLabels('price')}
        data-testid="startup-fee"
      >
        {startupFeeToDisplay}
      </ContentText>
    </>
  )
}
